/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Reader} from "../models/reader";
import {ReaderService} from "../services/reader.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ReadersResolver implements Resolve<Reader[]> {

  constructor(
    private mReaderService: ReaderService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Reader[]> {
    try {
      return await this.mReaderService.getAllReaders();
    } catch (error) {
      console.error("Problem resolving Readers... Error: " + error, error);
    }
  }

}
